<template>
    <div class="lds-ellipsis" :class="'lds-ellipsis-' + color">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</template>


<script>
    export default {
        name: "EdaEllipsisLoader",
        props: {
            color: {type: String, default: "white"}
        }

    }
</script>

<style>

    .lds-ellipsis {
        display: inline-block;
        position: relative;
        width: 64px;
        height: 11px;
    }

    .lds-ellipsis-white div{
        background: #fff;
    }

    .lds-ellipsis-blue div{
        background: #00A2FF;
    }

    .lds-ellipsis-green div{
        background: #00B27C;
    }

    .lds-ellipsis div {
        position: absolute;
        top: 0px;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }

    .lds-ellipsis div:nth-child(1) {
        left: 6px;
        animation: lds-ellipsis1 0.6s infinite;
    }

    .lds-ellipsis div:nth-child(2) {
        left: 6px;
        animation: lds-ellipsis2 0.6s infinite;
    }

    .lds-ellipsis div:nth-child(3) {
        left: 26px;
        animation: lds-ellipsis2 0.6s infinite;
    }

    .lds-ellipsis div:nth-child(4) {
        left: 45px;
        animation: lds-ellipsis3 0.6s infinite;
    }

    @keyframes lds-ellipsis1 {
        0% {
            transform: scale3d(0,0,0);
        }
        100% {
            transform: scale3d(1,1,1);
        }
    }

    @keyframes lds-ellipsis3 {
        0% {
            transform: scale3d(1,1,1);
        }
        100% {
            transform: scale3d(0,0,0);
        }
    }

    @keyframes lds-ellipsis2 {
        0% {
            transform: translate(0, 0);
        }
        100% {
            transform: translate(19px, 0);
        }
    }

</style>
